import { createFileRoute } from '@tanstack/react-router';

import type { AdminUserSort, DepartmentSort } from '~/api/types';
import { USER_ROLES } from '~/features/auth/roles';
import type { AdminUsersTabsValue } from '~/features/hcpAdministration/users/constants';
import { AdminUsers } from '~/features/hcpAdministration/users/users';
import type { AdminUsersSearchParams } from '~/types/AdminUsersRoute';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/hcp-admin/users')({
  component: AdminUsers,
  validateSearch: (
    search: Record<string, unknown>,
  ): AdminUsersSearchParams<
    AdminUsersTabsValue,
    AdminUserSort | DepartmentSort
  > => {
    // Validate and parse the search params into a typed state
    const defaultSortDir = search.sortDir === 'asc' ? 'asc' : 'desc';
    const sortDir = search.sortDir ? defaultSortDir : undefined;
    const filters = search.filters ?? undefined;
    const departmentId =
      typeof search.departmentId === 'string' ? search.departmentId : undefined;

    return {
      page: search.page ? Number(search.page) || 1 : undefined,
      sort:
        (search.sort as AdminUserSort | DepartmentSort | undefined) ??
        undefined,
      search: search.search ? decodeURI(search.search as string) : undefined,
      sortDir,
      departmentId,
      filters,
    };
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.HcpAdmin, USER_ROLES.NonHcpAdmin],
    });
  },
});
